import { createBrowserRouter, RouterProvider } from "react-router-dom";
import LoginPage from "./LoginPage";
import RouteErrorPage from './RouteErrorPage';
import useMe from './hooks/useMe';
import useDataVerify from './dataHooks/useDataVerify';
import useDataMe from './dataHooks/useDataMe';
import { getRouterBasename } from "./utils/utils";

const PrivateRoute = ({ element: Component, ...routeProps }) => {
  const { isVerified, hasAppAccess } = useMe()
  return ( isVerified && hasAppAccess ) ? <Component {...routeProps} /> : <LoginPage />;
};

const PublicRoute = ({ element: Component, ...routeProps }) => {
  return <Component {...routeProps} />;
};

export default ({
  routes = []
}) => {

  const { getIsVerified } = useDataVerify()
  const { fetchMe } = useDataMe()

  const verifyLoader = async () => {
    const isVerified = await getIsVerified()
    const me = await fetchMe()
    return { ...me, isVerified }
  };

  const publicLoader  = async () => {
    const me = await fetchMe()
    return me;
  }

  const parseRoute = (route) => {
    return route.map((routeObj) => {
      const {
        path,
        isPrivate,
      } = routeObj;
      const parsedRouteObj = { ...routeObj }
      if (path === '/') {
        parsedRouteObj.errorElement = <RouteErrorPage />;
      }

      if (isPrivate) {
        parsedRouteObj.element = <PrivateRoute {...routeObj} />;
        parsedRouteObj.loader = verifyLoader;
      } else {
        parsedRouteObj.element = <PublicRoute {...routeObj} />;
        parsedRouteObj.loader = publicLoader;
      }

      parsedRouteObj.shouldRevalidate = () => true;
      
      return parsedRouteObj
    })
  }

  const router = createBrowserRouter(parseRoute(routes), {
    basename: getRouterBasename(),
  });

  return <RouterProvider router={router} />
}
